import Componet from './Component'
export default Componet
